module.exports = __webpack_public_path__ + "static/pcp-mock-c4f74612d6875d1edb8edd544a8185ba.png";